// Mirrors GroupsController.GroupModel / GroupVisibility / GroupKind on the server. Numeric values
// must match the C# enums (JSON serializes them as numbers).
export enum GroupVisibility {
  Private = 0,
  Public = 1,
}

export enum GroupKind {
  Custom = 0,
  Personal = 1,
  Home = 2,
}

export type GroupModel = {
  Id: number;
  // The 8-char URL token (Guid prefix). The games-list view is addressed by this, not the numeric
  // Id — management calls (rename/delete/copy/import target) still use Id.
  Token: string;
  Name: string;
  Slug: string;
  Visibility: GroupVisibility;
  Kind: GroupKind;
  // The signed-in user owns this group.
  IsOwner: boolean;
  // The signed-in user may add games to it (owner of a normal group, or webmaster for Home).
  CanAdd: boolean;
  GameCount: number;
};
